import * as settingsActions from './actions';

import settingsReducer from './reducers';
import * as settingsSelectors from './selectors';

export { settingsActions, settingsSelectors };
export default settingsReducer;
